import { TabStyles } from '@tableau/widgets';
import { NestedCSSProperties } from 'typestyle/lib/types';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { cssClass, Style } from '../../style';

export namespace DraftStyles {
    const cssPrefix = 'Draft';

    export const DraftThumbnailTextStyle = cssClass(cssPrefix, '-thumbnail-text', {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
        color: 'white',
    });

    export const DraftTagsCardContainer = cssClass(cssPrefix, '-tag-container', {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginLeft: CommonStyles.Sizes.MediumSpace,
    });

    export const DraftTagBase: NestedCSSProperties = {
        marginRight: '8px',
        height: '18px',
        boxSizing: 'border-box',
        borderRadius: '4px',
        padding: `0 ${TabStyles!.Spacing!.DefaultSpace}px`,
        fontSize: CommonStyles.Sizes.SmallFontSize,
        textAlign: 'center',
        lineHeight: '18px'
    };

    export const DraftTag = cssClass(cssPrefix, '-tag', {
        ...DraftTagBase,
        color: '#fafafa',
        backgroundColor: CommonStyles.Colors.BadgeBlue,
        fontWeight: 'bold',
    });

    export const DraftUnpublishedTag = cssClass(cssPrefix, '-tag', {
        ...DraftTagBase,
        fontSize: CommonStyles.Sizes.SmallFontSize,
        color: CommonStyles.Colors.Grey77,
        backgroundColor: '#e1e1e1',
        fontWeight: 'normal'
    });

    export const ListViewContainer = cssClass(cssPrefix, '-list-tag-container', {
        marginLeft: CommonStyles.Sizes.DefaultSpace,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingRight: '8px',
    });
}

export namespace TooltipDraftIndicatorStyles {
    const cssPrefix = 'TooltipDraftIndicator';

    export const ContainerStyle = cssClass(cssPrefix, '-container', {
        display: 'flex',
        paddingRight: '8px',
        alignItems: 'baseline',
    });

    export const TextStyle = cssClass(cssPrefix, '-text', {
        display: 'inline',
        fontSize: CommonStyles.Sizes.NormalFontSize.toString() + 'px',
        letterSpacing: '0.2px',
        lineHeight: '1.5',
    });

    export const IconStyle = cssClass(cssPrefix, '-icon', {
        marginRight: '4px', verticalAlign: 'top',
    });

    export const buttonHoverStyle: Style = {
        $nest: {
            '&:hover:enabled': {
                textDecoration: 'underline',
                cursor: 'pointer',
                backgroundColor: 'transparent',
                color: CommonStyles.Colors.HyperlinkBlueHover
            },
        },
    };

    export const InlineButtonStyles: React.CSSProperties = {
        padding: `${TabStyles.Spacing.SmallSpace}px ${TabStyles.Spacing.DefaultSpace}px`,
        display: 'inline-flex',
        alignItems: 'center',
        color: CommonStyles.Colors.HyperlinkBlue
    };
}
